<template>
<div>
  <v-content>
    <section>
      <v-parallax :src="require('@/app/assets/images/nature42.jpg')" height="500">
        <v-layout row class="mt-4">
          <div :class="ui.textDisplay1Light">
            {{this.companyTitle2}} info
          </div>
          <v-spacer/>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" href="https://www.besea.com.au">
              <v-icon dark left>public</v-icon>
              besea
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" href="https://www.besea.com.au">
              <v-icon dark>public</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/commercial'">
              <v-icon dark>emoji_food_beverage</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/commercial'">
              <v-icon dark left>emoji_food_beverage</v-icon>
              plans
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/legal'">
              <v-icon dark>account_balance</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/legal'">
              <v-icon dark left>account_balance</v-icon>
              legal
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/'">
              <v-icon dark>home</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/'">
              <v-icon dark left>home</v-icon>
              home
            </v-btn>
          </div>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Pilbara, Western Austalia </div>
      </v-layout>
    </section>

    <section>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm10 lg6 offset-xs0 offset-sm1 offset-lg3>
          <span :class="ui.textHeadline">
            high reliability platform with secure access keys supported by state of the art cloud database services enabling fast data transfers between users
          </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm4 md4 lg2 offset-xs0 offset-md0 offset-lg3>
          <InfoCard :info="InfoCard1"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2 >
          <InfoCard :info="InfoCard2"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2>
          <InfoCard :info="InfoCard3"/>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax :src="require('@/app/assets/images/plant04.jpeg')" height="500">
        <v-layout column fill-height>
          <div :class="ui.textDisplay1Light">
            {{this.companyTitle2}} sign up
          </div>
          <v-layout align-center justify-start row fill-height>
            <v-btn outline small :color="ui.btnColorLight" :to="'/signin'">
              sign in
            </v-btn>
            <v-btn outline small :color="ui.btnColorLight" :to="'/signup'">
              sign up
            </v-btn>
          </v-layout>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage">
          Karratha Gas Plant, Woodside Energy Group Ltd.
        </div>
      </v-layout>
    </section>

    <v-container grid-list-xl>
      <v-layout row wrap justify-center class="my-5">
        <v-flex xs12 sm4>
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div :class="ui.textHeadline">images</div>
            </v-card-title>
            <v-card-text :class="ui.textDescription">
              all images are property of Woodside Energy Group Ltd. and Rio Tinto Ltd. Please read image and public material terms and conditions to review limitations and privileges to use these images in the respective companies websites.
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div :class="ui.textHeadline">{{this.companyTitle2}}</div>
            </v-card-title>
            <v-card-text :class="ui.textDescription">
              {{this.companyDescription3}}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>


    <PublicFooterPage/>

  </v-content>
</div>
</template>


<script>
/* eslint-disable */
import InfoCard from "../components/InfoCard"
import PublicFooterPage from "../components/PublicFooterPage"
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";

export default {
  components: {
    InfoCard,
    PublicFooterPage
  },
  mixins: [apptheme, publicGlobals],
  data() {
    return {
      currentPagePath: "/about",
      InfoCard1: {
        title: "Security",
        icon: "lock",
        text: "Your data security and privacy are our number one priority. The platform is highly integrated between facility owners, operations, engineering and maintenance team and our safeguards ensure that data security is our key promise to you."
      },
      InfoCard2: {
        title: "Mission",
        icon: "data_usage",
        text: "Deliver company management solutions to enable small and medium sized business to transform facility systems to low carbon and low cost operations. Everything we do is guided by our values: Innovation, Integrity, and Team."
      },
      InfoCard3: {
        title: "Vision",
        icon: "public",
        text: "Trusted partner to assist companies to transform to carbon neutral operations through data analytics, AI and cloud services to empower asset owners and operators to make decisions in the context of safety, cost and carbon."
      }
    };
  }
};
</script>
